import React from "react";

const Scorecard = () => (
  <div>
    <h3>Agile Scorecard</h3>
    <p>
      Assigns an Agile score at the end of the run in three categories based on
      various performance metrics.
    </p>
    <br />
    <br />
  </div>
);

export default Scorecard;
